export function isDevEnv() {
  return process.env.NODE_ENV === "development";
}

export function devMockEnabled(): boolean {
  return isDevEnv() && process.env.MOCK_DATA === "true";
}
